export var Certificate = {};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=Certificate.js.map